import React from 'react'
import isUndefined from 'lodash/isUndefined'
import { BStepper, BTitle, BText } from '@prague-digi/ui-components'
import { compose } from 'recompose'
import { connect, ConnectedProps } from 'react-redux'
import classNames from '@prague-digi/class-names'

import messages from '../../../../i18n'
import { ReduxState } from '../../../../types'
import { Routes } from '../../../../constants'
import { intl, IntlInterface } from '../../../../hoc'
import { InfoCheckbox } from '../../../../components'

import banknote from '../../../../assets/banknote.svg'

import SaveAndLeaveButton from '../SaveAndLeaveButton/SaveAndLeaveButton'

import styles from './styles.scss'

type Props = IntlInterface & ConnectedProps<typeof connector>

export const SidePanel = ({ actualStep, formatCzechCurrency, loanAmount, translate }: Props) => {
  const getTrackerConfig = (): any[] => {
    const subStepsPersonal: any[] = [
      {
        step: 1,
        msg: translate(messages.sidePanel.stepper.personalDetails.personalData),
      },
      {
        step: 2,
        msg: translate(messages.sidePanel.stepper.personalDetails.incomesOutcomes),
      },
      {
        step: 3,
        msg: translate(messages.sidePanel.stepper.personalDetails.offerForYou),
      },
    ]

    return [
      {
        step: 1,
        msg: translate(messages.sidePanel.stepper.personalDetails.title),
        subSteps: actualStep.step === 1 && actualStep.subStep ? subStepsPersonal : [],
      },
      {
        step: 2,
        msg: translate(messages.sidePanel.stepper.loanConfig),
      },
      {
        step: 3,
        msg: translate(messages.sidePanel.stepper.income),
      },
      {
        step: 4,
        msg: translate(messages.sidePanel.stepper.identity),
      },
      {
        step: 5,
        msg: translate(messages.sidePanel.stepper.docs),
      },
      {
        step: 6,
        msg: translate(messages.sidePanel.stepper.pennyTransfer),
      },
      {
        step: 7,
        msg: translate(messages.sidePanel.stepper.money),
      },
    ]
  }

  const showNeeds = actualStep.route === Routes.CLIENT_INFO

  return (
    <>
      {!isUndefined(actualStep.step) && (
        <div className={styles.SidePanel}>
          {showNeeds && (
            <div className={styles.needs}>
              <BTitle type="h5" theme={styles.title}>
                {translate(messages.sidePanel.needs.title)}
              </BTitle>
              <div className={styles.items}>
                {messages.sidePanel.needs.items.map((textObject: any) => (
                  <InfoCheckbox large key={textObject.id}>
                    {translate(textObject)}
                  </InfoCheckbox>
                ))}
              </div>
            </div>
          )}

          <div className={classNames(styles.stepper, { [styles.extraPadding]: showNeeds })}>
            <BTitle type="h5" theme={styles.title}>
              {translate(messages.sidePanel.topSection.title)}
            </BTitle>
            <BText type="primary" theme={styles.amount}>
              <img src={banknote} alt="" className={styles.icon} />
              {formatCzechCurrency(loanAmount)}
            </BText>
            <BStepper
              trackerConfig={getTrackerConfig()}
              progress={{ step: actualStep.step, subStep: actualStep.subStep }}
            />
          </div>

          <div
            className={classNames(styles.saveAndLeaveButtonWrapper, {
              [styles.extraPadding]: showNeeds,
            })}>
            <SaveAndLeaveButton />
          </div>
        </div>
      )}
    </>
  )
}

const connector = connect((state: ReduxState) => ({
  actualStep: state.wizard.actualStep,
  loanAmount: state.product.configuration?.loanAmount,
  term: state.product.configuration?.term,
}))

export const enhance = compose(connector, intl)

export default enhance(SidePanel)
